import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import './ComingSoon.css';

const ComingSoon = () => {
  // Upcoming features list - easily updatable
  const upcomingFeatures = [
    {
      id: 1,
      title: 'Comprehensive FAQ Section',
      description: 'Detailed answers to common pest control questions',
      icon: '🔍',
      estimatedTime: 'Coming this June'
    },
    {
      id: 2,
      title: 'Interactive Pest Guide',
      description: 'Visual guide to identify different types of pests',
      icon: '🐜',
      estimatedTime: 'Coming this July'
    },
    {
      id: 3,
      title: 'Treatment Calculator',
      description: 'Calculate estimated treatment costs for your space',
      icon: '🧮',
      estimatedTime: 'Coming this August'
    },
    {
      id: 4,
      title: 'Prevention Tips',
      description: 'Season-wise pest prevention guidelines',
      icon: '📋',
      estimatedTime: 'Coming this September'
    }
  ];

  return (
    <div className="coming-soon-container py-5">
      <div className="container">
        <motion.div
          className="text-center mb-5"
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
        >
          <h1 className="display-4 fw-bold">Coming Soon!</h1>
          <p className="lead text-muted">We're working on something amazing for you</p>
        </motion.div>

        {/* Features Grid */}
        <div className="row g-4 mb-5">
          {upcomingFeatures.map((feature, index) => (
            <motion.div
              className="col-md-6"
              key={feature.id}
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
            >
              <div className="feature-card h-100">
                <div className="feature-icon">{feature.icon}</div>
                <h3 className="feature-title">{feature.title}</h3>
                <p className="feature-description">{feature.description}</p>
                <div className="feature-timeline">{feature.estimatedTime}</div>
              </div>
            </motion.div>
          ))}
        </div>


        {/* Back to Home */}
        <motion.div
          className="text-center mt-5"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.5, delay: 0.5 }}
        >
          <Link to="/" className="btn btn-outline-danger btn-lg">
            Back to Home
          </Link>
        </motion.div>
      </div>
    </div>
  );
};

export default ComingSoon;
